import Icon from '@ant-design/icons';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import AuthCardLayout from 'global/AuthCardLayout';
import ChatSvg from 'global/Icons/ChatSvg';
import WhatsAppSvg from 'global/Icons/WhatsAppSvg';
import OtpMethodList from 'global/OtpMethodList';
import { useState } from 'react';
import { OtpChannel } from 'typings/auth';
import { SendButton } from './styled';

interface SendOTPMethodProps {
  title?: string;
  description?: string[];
  phone?: string;
  onSubmit?(value: string): void;
}

const SendOTPMethod = ({
  title = 'Choose OTP Sending Method',
  description = [
    'Make sure the phone number ',
    ' is correct before you send OTP',
  ],
  phone = '',
  onSubmit = () => {},
}: SendOTPMethodProps) => {
  const [selectedMethod, setSelectedMethod] = useState<OtpChannel>(
    OtpChannel.WhatsApp,
  );

  const handleMethodClick = (value: OtpChannel) => {
    setSelectedMethod(value);
  };

  const handleSubmit = () => {
    onSubmit(selectedMethod);
  };

  return (
    <AuthCardLayout wrapperClassName="register">
      <Text
        weight="700"
        size="24px"
        height="32px"
        align="center"
        color={color.highempahis}
      >
        {title}
      </Text>
      <Text size="16px" height="22px" color="#858585">
        {description[0]}
        <b>{phone.replace(/(\d{2})(\d{3})(\d{4})(\d{4})/, '+$1-$2-$3-$4')}</b>
        {description[1]}
      </Text>

      <OtpMethodList
        defaultMethod={selectedMethod}
        data={[
          {
            value: OtpChannel.WhatsApp,
            title: 'Send by WhatsApp',
            description: 'Free of charge',
            icon: <Icon component={WhatsAppSvg} style={{ color: '#00AB6B' }} />,
          },
          {
            value: OtpChannel.Sms,
            title: 'Send by SMS',
            description: 'Service charges may apply',
            icon: <Icon component={ChatSvg} style={{ color: '#00AB6B' }} />,
          },
        ]}
        onSelect={handleMethodClick}
      />

      <SendButton
        type="primary"
        onClick={handleSubmit}
        disabled={!selectedMethod}
      >
        Send Verification Code
      </SendButton>
    </AuthCardLayout>
  );
};

export default SendOTPMethod;
